module.exports = __webpack_public_path__ + "media/images/powerpoint/heroiks-background-0c5d685002a284a9d546a70d24918ed4.png";